import { Map } from 'immutable'

import { SHOW_MENU, HIDE_MENU } from '../actions'

const initialState = Map({
  showMenu: false,
})

const reduce = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MENU:
      return state.set('showMenu', true)
    case HIDE_MENU:
      return state.set('showMenu', false)
    default:
      return state
  }
}

export default reduce



// WEBPACK FOOTER //
// ./src/model/reducers/view.js